<template>
  <div
   class="container"   
    v-loading="loading"
    element-loading-text="正在提交..."
    element-loading-spinner="el-icon-loading">
    <el-upload
      v-show="uploadvisible"
      class="upload-demo"
      multiple
      drag
      action="123"
      :before-upload="beforeUpload"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <template #tip>
        <div class="el-upload__tip">只能上传 mkv/mp4 文件，且不超过 200M</div>
      </template>
    </el-upload>
    <div class="uploadprogress">
      <div style="text-align: left">{{ videoname }}</div>
      <div class="upload-done" v-show="uploadDoneShow">上传完成</div>
      <el-progress
        :text-inside="true"
        :stroke-width="2"
        :percentage="percentage"
      ></el-progress>
    </div>

    <div class="info" v-show="infovisible">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="封面" prop="conver">
          <div id="js_conver"></div>
        </el-form-item>
        <el-form-item label="角色名" prop="playername">
          <el-input v-model.number="ruleForm.playername"></el-input>
        </el-form-item>
        <el-form-item label="伤害(单位万亿)" prop="hurtvalue">
          <el-input v-model="ruleForm.hurtvalue"></el-input>
        </el-form-item>
        <el-form-item label="角色类型" prop="playertype">
          <el-cascader-panel
            :options="options1"
            v-model="ruleForm.playertype"
          ></el-cascader-panel>
        </el-form-item>
        <el-form-item label="所在区" prop="district">
          <el-cascader-panel
            :options="options2"
            v-model="ruleForm.district"
          ></el-cascader-panel>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="ex-btn"
            @click="submitForm('ruleForm')"
            >立即加入</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="tips">
      上传视频，即表示您已同意 <a href="#">哔哩哔哩使用协议</a> 与
      <a href="#">哔哩哔哩创作公约</a> ，请勿上传色情，反动等违法视频。
    </div>
  </div>
</template>

<style scoped>
.container {
  background-color: white;
  padding-top: 32px;
  padding-bottom: 32px;
}
.tips {
  margin-top: 32px;
  color: #99a2aa;
  font-size: 12px;
}
a {
  color: #00a1d6;
  font-size: 13px;
}
.info {
  width: 70%;
  margin: 0 auto;
}
.upload-done {
  text-align: left;
  font-size: 12px;
  color: #99a2aa;
}
.uploadprogress {
  padding: 16px;
}
</style>

<script>
export default {
  data() {
    var validatePlayerName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("角色名不能为空"));
      } else {
        if (this.ruleForm.playername !== "") {
          //this.$refs.ruleForm.validateField("phone");
        }
        callback();
      }
    };
    var validateHurtVal = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("伤害不能为空"));
      } else {
        if (this.ruleForm.hurtvalue !== "") {
          //this.$refs.ruleForm.validateField("pass");
        }
        callback();
      }
    };
    var validatePlayerType = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("角色类型不能为空"));
      } else {
        if (this.ruleForm.playertype !== "") {
          //this.$refs.ruleForm.validateField("pass");
        }
        callback();
      }
    };
    var validateDistrict = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("所在区不能为空"));
      } else {
        if (this.ruleForm.district !== "") {
          //this.$refs.ruleForm.validateField("pass");
        }
        callback();
      }
    };
    return {
      //token:{Authorization:localStorage.getItem('Authorization')}，
      percentage: 0,
      videoname: "",
      loading:false,
      uploadvisible: true,
      infovisible: false,
      uploadDoneShow: false,
      ruleForm: {
        playername: "",
        playertype: "",
        district: "",
        hurtvalue: "",
        videopath: "",
        cover: "",
      },
      rules: {
        playername: [{ validator: validatePlayerName, trigger: "blur" }],
        playertype: [{ validator: validatePlayerType, trigger: "blur" }],
        district: [{ validator: validateDistrict, trigger: "blur" }],
        hurtvalue: [{ validator: validateHurtVal, trigger: "blur" }],
      },
      options1: [
        {
          value: "ghostman",
          label: "鬼剑士",
          children: [
            {
              value: "狂战士",
              label: "狂战士",
            },
            {
              value: "剑魂",
              label: "剑魂",
            },
            {
              value: "鬼泣",
              label: "鬼泣",
            },
            {
              value: "阿修罗",
              label: "阿修罗",
            },
            {
              value: "剑影",
              label: "剑影",
            },
          ],
        },
        {
          value: "ghostwomen",
          label: "女鬼剑",
          children: [
            {
              value: "驭剑士",
              label: "驭剑士",
            },
            {
              value: "暗殿骑士",
              label: "暗殿骑士",
            },
            {
              value: "契魔者",
              label: "契魔者",
            },
            {
              value: "流浪武士",
              label: "流浪武士",
            },
          ],
        },
        {
          value: "gunsword",
          label: "枪剑士",
          children: [
            {
              value: "铁血统帅",
              label: "铁血统帅",
            },
            {
              value: "巅峰狂徒",
              label: "巅峰狂徒",
            },
            {
              value: "弑心镇魂者",
              label: "弑心镇魂者",
            },
            {
              value: "未来开拓者",
              label: "未来开拓者",
            },
          ],
        },

        {
          value: "fightman",
          label: "格斗家",
          children: [
            {
              value: "气功师",
              label: "气功师",
            },
            {
              value: "散打",
              label: "散打",
            },
            {
              value: "街霸",
              label: "街霸",
            },
            {
              value: "柔道家",
              label: "柔道家",
            },
          ],
        },

        {
          value: "fightgirl",
          label: "格斗家女",
          children: [
            {
              value: "气功师",
              label: "气功师",
            },
            {
              value: "柔道家",
              label: "柔道家",
            },
            {
              value: "街霸",
              label: "街霸",
            },
            {
              value: "散打",
              label: "散打",
            },
          ],
        },

        {
          value: "gunman",
          label: "神枪手",
          children: [
            {
              value: "漫游",
              label: "漫游",
            },
            {
              value: "枪炮师",
              label: "枪炮师",
            },
            {
              value: "机械师",
              label: "机械师",
            },
            {
              value: "弹药专家",
              label: "弹药专家",
            },
          ],
        },

        {
          value: "gungirl",
          label: "女枪手",
          children: [
            {
              value: "漫游",
              label: "漫游",
            },
            {
              value: "枪炮师",
              label: "枪炮师",
            },
            {
              value: "机械师",
              label: "机械师",
            },
            {
              value: "弹药专家",
              label: "弹药专家",
            },
          ],
        },

        {
          value: "maginman",
          label: "魔法师男",
          children: [
            {
              value: "元素爆破",
              label: "元素爆破",
            },
            {
              value: "冰结师",
              label: "冰结师",
            },
            {
              value: "血法师",
              label: "血法师",
            },
            {
              value: "逐风者",
              label: "逐风者",
            },
            {
              value: "次元行者",
              label: "次元行者",
            },
          ],
        },
        {
          value: "magingirl",
          label: "魔法师女",
          children: [
            {
              value: "元素师",
              label: "元素师",
            },
            {
              value: "召唤师",
              label: "召唤师",
            },
            {
              value: "战斗法师",
              label: "战斗法师",
            },
            {
              value: "魔道学者",
              label: "魔道学者",
            },
            {
              value: "小魔女",
              label: "小魔女",
            },
          ],
        },
        {
          value: "godman",
          label: "圣职者男",
          children: [
            {
              value: "圣骑士",
              label: "圣骑士",
            },
            {
              value: "蓝拳圣使",
              label: "蓝拳圣使",
            },
            {
              value: "驱魔师",
              label: "驱魔师",
            },
            {
              value: "复仇者",
              label: "复仇者",
            },
          ],
        },
        {
          value: "godgirl",
          label: "圣职者女",
          children: [
            {
              value: "圣骑士",
              label: "圣骑士",
            },
            {
              value: "异端审判者",
              label: "异端审判者",
            },
            {
              value: "巫女",
              label: "巫女",
            },
            {
              value: "诱魔者",
              label: "诱魔者",
            },
          ],
        },
        {
          value: "darkgirl",
          label: "暗夜使者",
          children: [
            {
              value: "刺客",
              label: "刺客",
            },
            {
              value: "死灵术士",
              label: "死灵术士",
            },
            {
              value: "忍者",
              label: "忍者",
            },
            {
              value: "影舞者",
              label: "影舞者",
            },
          ],
        },
        {
          value: "gurdgirl",
          label: "守护者",
          children: [
            {
              value: "龙骑士",
              label: "龙骑士",
            },
            {
              value: "精灵骑士",
              label: "精灵骑士",
            },
            {
              value: "帕拉丁",
              label: "帕拉丁",
            },
            {
              value: "混沌魔灵",
              label: "混沌魔灵",
            },
          ],
        },
        {
          value: "magicman",
          label: "魔枪士",
          children: [
            {
              value: "不灭战神",
              label: "不灭战神",
            },
            {
              value: "圣武枪魂",
              label: "圣武枪魂",
            },
            {
              value: "屠戮之魂",
              label: "屠戮之魂",
            },
            {
              value: "幽影夜神",
              label: "幽影夜神",
            },
          ],
        },
        {
          value: "outman",
          label: "外传职业",
          children: [
            {
              value: "黑暗武士",
              label: "黑暗武士",
            },
            {
              value: "缔造者",
              label: "缔造者",
            },
          ],
        },
      ],
      options2: [
        {
          value: "kua1",
          label: "跨一(广东/广西)",
          children: [
            {
              value: "广西5区",
              label: "广西5区",
            },
            {
              value: "广西3区",
              label: "广西3区",
            },
            {
              value: "广西2/4区",
              label: "广西2/4区",
            },
            {
              value: "广西1区",
              label: "广西1区",
            },
            {
              value: "广州1/2区",
              label: "广州1/2区",
            },
            {
              value: "广东13区",
              label: "广东13区",
            },
            {
              value: "广东12区",
              label: "广东12区",
            },
            {
              value: "广东11区",
              label: "广东11区",
            },
            {
              value: "广东10区",
              label: "广东10区",
            },
            {
              value: "广东9区",
              label: "广东9区",
            },
            {
              value: "广东8区",
              label: "广东8区",
            },
            {
              value: "广东7区",
              label: "广东7区",
            },
            {
              value: "广东6区",
              label: "广东6区",
            },
            {
              value: "广东5区",
              label: "广东5区",
            },
            {
              value: "广东4区",
              label: "广东4区",
            },
            {
              value: "广东2区",
              label: "广东2区",
            },
            {
              value: "广东1区",
              label: "广东1区",
            },
          ],
        },
        {
          value: "kua2",
          label: "跨二(湖南)",
          children: [
            {
              value: "湖南7区",
              label: "湖南7区",
            },
            {
              value: "湖南6区",
              label: "湖南6区",
            },
            {
              value: "湖南5区",
              label: "湖南5区",
            },
            {
              value: "湖南4区",
              label: "湖南4区",
            },
            {
              value: "湖南3区",
              label: "湖南3区",
            },
            {
              value: "湖南2区",
              label: "湖南2区",
            },
            {
              value: "湖南1区",
              label: "湖南1区",
            },
            {
              value: "湖北8区",
              label: "湖北8区",
            },
            {
              value: "湖北7区",
              label: "湖北7区",
            },
            {
              value: "湖北6区",
              label: "湖北6区",
            },
            {
              value: "湖北5区",
              label: "湖北5区",
            },
            {
              value: "湖北4区",
              label: "湖北4区",
            },
            {
              value: "湖北3区",
              label: "湖北3区",
            },
            {
              value: "湖北2区",
              label: "湖北2区",
            },
            {
              value: "湖北1区",
              label: "湖北1区",
            },
          ],
        },

        {
          value: "kua3a",
          label: "跨三A(四川)",
          children: [
            {
              value: "新疆1区",
              label: "新疆1区",
            },
            {
              value: "西北2/3区",
              label: "西北2/3区",
            },
            {
              value: "西北1区",
              label: "西北1区",
            },
            {
              value: "四川6区",
              label: "四川6区",
            },
            {
              value: "四川5区",
              label: "四川5区",
            },
            {
              value: "四川4区",
              label: "四川4区",
            },
            {
              value: "四川3区",
              label: "四川3区",
            },
            {
              value: "四川2区",
              label: "四川2区",
            },
            {
              value: "四川1区",
              label: "四川1区",
            },
          ],
        },

        {
          value: "kua3b",
          label: "跨三B",
          children: [
            {
              value: "贵州1区",
              label: "贵州1区",
            },
            {
              value: "云南1区",
              label: "云南1区",
            },
            {
              value: "云贵1区",
              label: "云贵1区",
            },
            {
              value: "陕西2/3区",
              label: "陕西2/3区",
            },
            {
              value: "陕西1区",
              label: "陕西1区",
            },
            {
              value: "重庆2区",
              label: "重庆2区",
            },
            {
              value: "重庆1区",
              label: "重庆1区",
            },
            {
              value: "西南3区",
              label: "西南3区",
            },
            {
              value: "西南2区",
              label: "西南2区",
            },
            {
              value: "西南1区",
              label: "西南1区",
            },
          ],
        },

        {
          value: "kua4",
          label: "跨四",
          children: [
            {
              value: "江西3区",
              label: "江西3区",
            },
            {
              value: "福建3/4区",
              label: "福建3/4区",
            },
            {
              value: "安徽3区",
              label: "安徽3区",
            },
            {
              value: "上海4/5区",
              label: "上海4/5区",
            },
            {
              value: "浙江7区",
              label: "浙江7区",
            },
            {
              value: "浙江6区",
              label: "浙江6区",
            },
            {
              value: "浙江4/5区",
              label: "浙江4/5区",
            },
            {
              value: "江苏8区",
              label: "江苏8区",
            },
            {
              value: "江苏6区",
              label: "江苏6区",
            },
            {
              value: "江苏5/7区",
              label: "江苏5/7区",
            },
          ],
        },

        {
          value: "kua5",
          label: "跨五(江浙)",
          children: [
            {
              value: "江西2区",
              label: "江西2区",
            },
            {
              value: "江西1区",
              label: "江西1区",
            },
            {
              value: "福建2区",
              label: "福建2区",
            },
            {
              value: "福建1区",
              label: "福建1区",
            },
            {
              value: "安徽2区",
              label: "安徽2区",
            },
            {
              value: "安徽1区",
              label: "安徽1区",
            },
            {
              value: "上海3区",
              label: "上海3区",
            },
            {
              value: "上海2区",
              label: "上海2区",
            },
            {
              value: "上海1区",
              label: "上海1区",
            },
            {
              value: "浙江3区",
              label: "浙江3区",
            },
            {
              value: "浙江2区",
              label: "浙江2区",
            },
            {
              value: "浙江1区",
              label: "浙江1区",
            },
            {
              value: "江苏4区",
              label: "江苏4区",
            },
            {
              value: "江苏3区",
              label: "江苏3区",
            },
            {
              value: "江苏2区",
              label: "江苏2区",
            },
            {
              value: "江苏1区",
              label: "江苏1区",
            },
          ],
        },

        {
          value: "kua6",
          label: "跨六",
          children: [
            {
              value: "河南2区",
              label: "河南2区",
            },
            {
              value: "河南1区",
              label: "河南1区",
            },
            {
              value: "山西1区",
              label: "山西1区",
            },
            {
              value: "吉林1/2区",
              label: "吉林1/2区",
            },
            {
              value: "黑龙江1区",
              label: "黑龙江1区",
            },
            {
              value: "华北3区",
              label: "华北3区",
            },
            {
              value: "华北2区",
              label: "华北2区",
            },
            {
              value: "华北1区",
              label: "华北1区",
            },
            {
              value: "辽宁1区",
              label: "辽宁1区",
            },
            {
              value: "河北1区",
              label: "河北1区",
            },
            {
              value: "山东2/7区",
              label: "山东2/7区",
            },
            {
              value: "山东1区",
              label: "山东1区",
            },
            {
              value: "东北3/7区",
              label: "东北3/7区",
            },
            {
              value: "东北2区",
              label: "东北2区",
            },
            {
              value: "东北1区",
              label: "东北1区",
            },
            {
              value: "北京2/4区",
              label: "北京2/4区",
            },
            {
              value: "北京1区",
              label: "北京1区",
            },
          ],
        },

        {
          value: "kua7",
          label: "跨七(河南)",
          children: [
            {
              value: "河南7区",
              label: "河南7区",
            },
            {
              value: "河南6区",
              label: "河南6区",
            },
            {
              value: "河南5区",
              label: "河南5区",
            },
            {
              value: "河南4区",
              label: "河南4区",
            },
            {
              value: "河南3区",
              label: "河南3区",
            },
            {
              value: "辽宁3区",
              label: "辽宁3区",
            },
            {
              value: "辽宁2区",
              label: "辽宁2区",
            },
            {
              value: "河北5区",
              label: "河北5区",
            },
            {
              value: "河北4区",
              label: "河北4区",
            },
            {
              value: "河北2/3区",
              label: "河北2/3区",
            },
            {
              value: "东北4/5/6区",
              label: "东北4/5/6区",
            },
          ],
        },

        {
          value: "kua8",
          label: "跨八",
          children: [
            {
              value: "内蒙古1区",
              label: "内蒙古1区",
            },
            {
              value: "天津1区",
              label: "天津1区",
            },
            {
              value: "山西2区",
              label: "山西2区",
            },
            {
              value: "黑龙江2/3区",
              label: "黑龙江2/3区",
            },
            {
              value: "华北4区",
              label: "华北4区",
            },
            {
              value: "山东6区",
              label: "山东6区",
            },
            {
              value: "山东5区",
              label: "山东5区",
            },
            {
              value: "山东4区",
              label: "山东4区",
            },
            {
              value: "山东3区",
              label: "山东3区",
            },
            {
              value: "北京3区",
              label: "北京3区",
            },
          ],
        },
      ],
    };
  },
  methods: {
    beforeUpload(file) {
      //限制只能上传200M的视频文件
      const isLt10M = file.size / 1024 / 1024 < 200;
      if (!isLt10M) {
        alert("视频大小不能超过200M");
        return false;
      }
      this.videoname = file.name;
      let _this = this;
      let fd = new FormData();
      fd.append("filename", file);
      this.uploadvisible = false;
      this.$http
        .post("/api/file/", fd, {
          onUploadProgress: (progressEvent) => {
            let percent =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0;
            //调用onProgress方法来显示进度条，需要传递个对象 percent为进度值
            _this.percentage = percent;
            if (percent >= 99) {
              _this.uploadDoneShow = true;
            }
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            _this.infovisible = true;
            _this.ruleForm.videopath = res.data.msg;
            _this.ruleForm.cover=res.data.data;
            //通过前端获取视频封面
            //this.getVideoConver();
            var image = document.createElement("img");
            image.src =_this.GLOBAL.baseURL + res.data.data;
            document.getElementById("js_conver").appendChild(image);
          } else {
            this.uploadvisible = true;
            this.$alert("视频上传失败，请重试");
          }

          console.log(res);
        })
        .catch((res) => {
          _this.uploadvisible = true;
          console.log(res);
        });
      return false;
    },
    getVideoConver() {
      let dataURL = "";
      let url = this.GLOBAL.baseURL+ this.ruleForm.videopath;
      let video = document.createElement("video");
      let _this = this;
      //video.setAttribute("crossOrigin", "anonymous"); //处理跨域
      video.setAttribute("src", url);
      video.setAttribute("width", 400);
      video.setAttribute("height", 240);
      video.addEventListener("loadeddata", function () {
        setTimeout(() => {
          video.pause();
          let canvas = document.createElement("canvas"),
            width = video.width, //canvas的尺寸和图片一样
            height = video.height;
          canvas.width = width;
          canvas.height = height;
          canvas.getContext("2d").drawImage(video, 0, 0, width, height); //绘制canvas
          dataURL = canvas.toDataURL(); //转换为base64
          let postData = new URLSearchParams();
          postData.append("imgdata", dataURL);
          _this.$http
            .post("/api/videoconver/", postData)
            .then((res) => {
              _this.ruleForm.converpath = res.data;
              var image = document.createElement("img");
              image.src = res.data;
              document.getElementById("js_conver").appendChild(image);
            })
            .catch((err) => {
              console.log(err);
            });
        }, 300);
      });

      video.play();
    },
    submitForm(formName) {
      let _this=this;
      this.loading=true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var objData = {};
          for (let key in this.ruleForm) {
            if (key == "district") {
              //所在区需要特需处理一下
              objData[key] = this.ruleForm[key][1];
              continue;
            }
            if (key == "playertype") {
              //角色类型需要特需处理一下
              objData[key] = this.ruleForm[key][1];
              continue;
            }
            objData[key] = this.ruleForm[key];

            //formData.append(key, this.ruleForm[key]);
          }
          var jsonStr = JSON.stringify(objData);
          this.$http
            .post("/api/Player", JSON.parse(jsonStr))
            .then((r) => {
              console.log(r);
              //上传成功
              if (r.data.code == 200) {
                // this.$alert(
                //   "提交成功，大概需要三个工作日完成审核，审核通过后才能成功加入."
                // );
                //强制刷新页面,以下方法都不起作用
                //this.$forceUpdate();
                //this.$router.push({ name: "index" });
                //_this.$router.push({name:"fileupload"});
                //_this.update=true;//强制刷新页面
                _this.$router.push({name:"joinsucc"});
              } else {
                this.$alert(r.data.msg, "", {
                  confirmButtonText: "确定",
                });
              }
              _this.loading=false;
            })
            .catch((r) => {
              if (r.response.status === 401) {
                //需要重新登录
                this.$router.push({ name: "login" });
              }
              _this.loading=false;
              console.log(r);
            });
        } else {
          console.log("error submit!!");
          _this.loading=false;
          return false;
        }
      });
    },
  },
};
</script>